export const CTA_ENDPOINTS = {
  contact: '/api/public/inquire',
  inquire: '/api/public/inquire',
  brochureRequest: '/api/public/contact/send-otp',
  brochureVerify: '/api/public/contact/verify-otp-download',
  paymentPlanRequest: '/api/public/paymentplan-request',
  paymentPlanVerify: '/api/public/paymentplan-verify'
};

export const CTA_CONFIG = {
  home: {
    mode: 'contact',
    endpoint: CTA_ENDPOINTS.contact,
    ctaKey: 'home',
    requestType: 'contact',
    fields: {
      subject: true,
      listingType: true,
      country: true,
      timeline: false,
      financing: false,
      budgetRange: false,
      budgetAmount: false,
      message: true
    },
    required: {
      subject: true,
      message: true
    },
    labels: {
      En: { btn: 'Initiate Strategic Dialogue', title: 'JANUS PRIVATE DESK', subtitle: 'Private strategic inquiry' },
      Fr: { btn: 'Initier le dialogue stratégique', title: 'JANUS PRIVATE DESK', subtitle: 'Demande stratégique privée' },
      Ar: { btn: 'بدء حوار استراتيجي', title: 'مكتب يانوس الخاص', subtitle: 'استفسار استراتيجي خاص' }
    }
  },

  janus: {
    mode: 'contact',
    endpoint: CTA_ENDPOINTS.contact,
    ctaKey: 'janus',
    requestType: 'contact',
    fields: {
      subject: true,
      listingType: true,
      country: true,
      timeline: false,
      financing: false,
      budgetRange: false,
      budgetAmount: false,
      message: true
    },
    required: {
      subject: true,
      message: true
    },
    labels: {
      En: { btn: 'Initiate Strategic Dialogue', title: 'JANUS PRIVATE DESK', subtitle: 'A private Janus advisory request' },
      Fr: { btn: 'Initier le dialogue stratégique', title: 'JANUS PRIVATE DESK', subtitle: 'Une demande de conseil privée Janus' },
      Ar: { btn: 'بدء حوار استراتيجي', title: 'مكتب يانوس الخاص', subtitle: 'طلب استشاري خاص من يانوس' }
    }
  },

  asset: {
    mode: 'contact',
    endpoint: CTA_ENDPOINTS.contact,
    ctaKey: 'asset',
    requestType: 'asset-management',
    fields: {
      subject: false,
      listingType: false,
      country: true,
      timeline: true,
      financing: false,
      budgetRange: true,
      budgetAmount: true,
      message: true
    },
    required: {
      subject: false,
      message: true
    },
    defaults: {
      subject: 'wealth-advisory'
    },
    labels: {
      En: { btn: 'Speak to an Advisor', title: 'ASSET MANAGEMENT', subtitle: 'Discuss allocation, preservation and deployment of capital' },
      Fr: { btn: 'Parler à un conseiller', title: "GESTION D'ACTIFS", subtitle: 'Discuter allocation, préservation et déploiement du capital' },
      Ar: { btn: 'تحدث إلى مستشار', title: 'إدارة الأصول', subtitle: 'ناقش تخصيص رأس المال وحمايته وتوظيفه' }
    }
  },

  digital: {
    mode: 'contact',
    endpoint: CTA_ENDPOINTS.contact,
    ctaKey: 'digital',
    requestType: 'digital-assets',
    fields: {
      subject: false,
      listingType: false,
      country: true,
      timeline: true,
      financing: false,
      budgetRange: true,
      budgetAmount: true,
      message: true
    },
    required: {
      subject: false,
      message: true
    },
    defaults: {
      subject: 'digital-assets'
    },
    labels: {
      En: { btn: 'Speak to an Advisor', title: 'DIGITAL ASSETS', subtitle: 'Discuss exposure, treasury, custody and crypto strategy' },
      Fr: { btn: 'Parler à un conseiller', title: 'ACTIFS NUMÉRIQUES', subtitle: 'Discuter exposition, trésorerie, custody et stratégie crypto' },
      Ar: { btn: 'تحدث إلى مستشار', title: 'الأصول الرقمية', subtitle: 'ناقش التعرض والأمانة والاستراتيجية الرقمية' }
    }
  },

  sovereignty: {
    mode: 'contact',
    endpoint: CTA_ENDPOINTS.contact,
    ctaKey: 'sovereignty',
    requestType: 'sovereignty',
    fields: {
      subject: false,
      listingType: false,
      country: true,
      timeline: true,
      financing: false,
      budgetRange: false,
      budgetAmount: false,
      message: true
    },
    required: {
      subject: false,
      message: true
    },
    defaults: {
      subject: 'corporate-sovereignty'
    },
    labels: {
      En: { btn: 'Speak to an Advisor', title: 'CORPORATE SOVEREIGNTY', subtitle: 'Structure mobility, protection and strategic independence' },
      Fr: { btn: 'Parler à un conseiller', title: 'SOUVERAINETÉ CORPORATIVE', subtitle: 'Structurer mobilité, protection et indépendance stratégique' },
      Ar: { btn: 'تحدث إلى مستشار', title: 'السيادة المؤسسية', subtitle: 'هيكلة التنقل والحماية والاستقلال الاستراتيجي' }
    }
  },

  article: {
    mode: 'contact',
    endpoint: CTA_ENDPOINTS.contact,
    ctaKey: 'article',
    requestType: 'article-inquiry',
    fields: {
      subject: false,
      listingType: false,
      country: true,
      timeline: false,
      financing: false,
      budgetRange: false,
      budgetAmount: false,
      message: true
    },
    required: {
      subject: false,
      message: true
    },
    defaults: {
      subject: 'wealth-advisory'
    },
    labels: {
      En: { btn: 'Speak to an Advisor', title: 'WEALTH STRATEGY', subtitle: 'Continue the conversation with a tailored advisory request' },
      Fr: { btn: 'Parler à un conseiller', title: 'STRATÉGIE PATRIMONIALE', subtitle: 'Poursuivre l’échange via une demande sur mesure' },
      Ar: { btn: 'تحدث إلى مستشار', title: 'استراتيجية الثروة', subtitle: 'واصل النقاش عبر طلب استشاري مخصص' }
    }
  },

  'property-membership': {
    mode: 'contact',
    endpoint: CTA_ENDPOINTS.contact,
    ctaKey: 'property-membership',
    requestType: 'membership',
    fields: {
      subject: false,
      listingType: false,
      country: true,
      timeline: false,
      financing: false,
      budgetRange: false,
      budgetAmount: false,
      message: true
    },
    required: {
      subject: false,
      message: true
    },
    defaults: {
      subject: 'janus-circle'
    },
    labels: {
      En: { btn: 'Become a Member', title: 'JANUS PRIVATE VAULT', subtitle: 'Request private access and member eligibility review' },
      Fr: { btn: 'Devenir Membre', title: 'ESPACE PRIVÉ JANUS', subtitle: 'Demander un accès privé et un examen d’éligibilité' },
      Ar: { btn: 'كن عضوا', title: 'خزنة جانوس الخاصة', subtitle: 'اطلب الوصول الخاص ومراجعة الأهلية' }
    }
  },

  realestate: {
    mode: 'contact',
    endpoint: CTA_ENDPOINTS.contact,
    ctaKey: 'realestate',
    requestType: 'real-estate',
    fields: {
      subject: false,
      listingType: false,
      country: true,
      timeline: true,
      financing: true,
      budgetRange: true,
      budgetAmount: true,
      message: true
    },
    required: {
      subject: false,
      message: true
    },
    defaults: {
      subject: 'real-estate'
    },
    labels: {
      En: { btn: 'Request Property Guidance', title: 'REAL ESTATE ADVISORY', subtitle: 'Discuss acquisition strategy, timing and preferred structure' },
      Fr: { btn: 'Demander un accompagnement', title: 'CONSEIL IMMOBILIER', subtitle: 'Discuter stratégie d’acquisition, timing et structure' },
      Ar: { btn: 'اطلب استشارة عقارية', title: 'الاستشارات العقارية', subtitle: 'ناقش استراتيجية الشراء والتوقيت والهيكلة' }
    }
  },

  'property-brochure': {
    mode: 'brochureRequest',
    endpoint: CTA_ENDPOINTS.brochureRequest,
    verifyEndpoint: CTA_ENDPOINTS.brochureVerify,
    ctaKey: 'property-brochure',
    requestType: 'brochure',
    fields: {
      subject: false,
      listingType: false,
      country: true,
      timeline: true,
      financing: true,
      budgetRange: true,
      budgetAmount: true,
      message: false
    },
    required: {
      subject: false,
      message: false
    },
    defaults: {
      subject: 'real-estate'
    },
    labels: {
      En: { btn: 'Download Brochure', title: 'PROJECT BROCHURE', subtitle: 'Unlock the brochure after verification' },
      Fr: { btn: 'Télécharger la brochure', title: 'BROCHURE DU PROJET', subtitle: 'Débloquer la brochure après vérification' },
      Ar: { btn: 'تحميل الكتيب', title: 'كتيب المشروع', subtitle: 'افتح الكتيب بعد التحقق' }
    }
  },

  'property-payment-plan': {
    mode: 'paymentPlanRequest',
    endpoint: CTA_ENDPOINTS.paymentPlanRequest,
    verifyEndpoint: CTA_ENDPOINTS.brochureVerify,
    ctaKey: 'property-payment-plan',
    requestType: 'paymentplan',
    fields: {
      subject: false,
      listingType: false,
      country: true,
      timeline: true,
      financing: true,
      budgetRange: true,
      budgetAmount: true,
      message: false
    },
    required: {
      subject: false,
      message: false
    },
    defaults: {
      subject: 'real-estate'
    },
    labels: {
      En: { btn: 'Access Payment Plan', title: 'PAYMENT PLAN ACCESS', subtitle: 'Unlock the payment plan after verification' },
      Fr: { btn: 'Accéder au plan de paiement', title: 'ACCÈS PLAN DE PAIEMENT', subtitle: 'Débloquer le plan de paiement après vérification' },
      Ar: { btn: 'الوصول إلى خطة الدفع', title: 'الوصول إلى خطة الدفع', subtitle: 'افتح خطة الدفع بعد التحقق' }
    }
  },

  'property-inquire': {
    mode: 'inquire',
    endpoint: CTA_ENDPOINTS.inquire,
    ctaKey: 'property-inquire',
    requestType: 'property-inquiry',
    fields: {
      subject: false,
      listingType: false,
      country: true,
      timeline: true,
      financing: true,
      budgetRange: true,
      budgetAmount: true,
      message: true
    },
    required: {
      subject: false,
      message: true
    },
    defaults: {
      subject: 'real-estate'
    },
    labels: {
      En: { btn: 'Speak to an Advisor', title: 'PROPERTY INQUIRY', subtitle: 'Request details and speak with our advisory desk' },
      Fr: { btn: 'Parler à un conseiller', title: "DEMANDE D'INFORMATION", subtitle: 'Demander des détails et parler à notre desk' },
      Ar: { btn: 'تحدث إلى مستشار', title: 'استفسار عن عقار', subtitle: 'اطلب التفاصيل وتحدث مع فريقنا' }
    }
  }
};
